module.exports = __webpack_public_path__ + "img/zombie.bd6300e8.gif";